module.exports = __webpack_public_path__ + "media/input5.c5fdd0fa.wav";